/* sugar:assets/announcement-column-link.js@2.0.0 */
/*
 * Announcement column link — one destination for a whole column of blocks.
 *
 * The column carries data-column-link (where it goes) and, when the merchant asked for it,
 * data-column-new-tab. The column also renders a real link of its own, which is what keyboard
 * and screen reader visitors follow and what draws the focus ring; that link takes no mouse
 * clicks, so this file is what a mouse click goes through.
 *
 * A click is passed on unless it landed somewhere that already does its own thing — a link, a
 * button, a form control, a popup trigger — or unless the visitor was selecting text, so a
 * Buy Button or a Link Button inside a linked column keeps its own destination.
 *
 * In the theme editor a click selects the block the merchant aimed at instead of leaving the
 * page; the link still works everywhere the storefront is being viewed.
 */
(function () {
  if (window.SugarAnnouncementColumnLink) return;
  window.SugarAnnouncementColumnLink = true;

  if (window.Shopify && window.Shopify.designMode) return;

  var OWN_ACTION =
    'a[href], button, input, select, textarea, label, summary, [role="button"], [role="link"], [data-popup-open], [contenteditable="true"]';

  function follow(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var column = target.closest('[data-column-link]');
    if (!column) return;
    if (target.closest(OWN_ACTION)) return;

    var selection = window.getSelection && window.getSelection();
    if (selection && String(selection).length) return;

    var href = column.getAttribute('data-column-link');
    if (!href) return;

    e.preventDefault();

    if (column.hasAttribute('data-column-new-tab') || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) {
      window.open(href, '_blank', 'noopener');
    } else {
      window.location.assign(href);
    }
  }

  document.addEventListener('click', follow);

  // Middle click reports as auxclick, never as click.
  document.addEventListener('auxclick', function (e) {
    if (e.button === 1) follow(e);
  });
})();
